<template>
  <modal
    id="demo-modal"
    :size="'lg'"
    :confirm-text="'Save'"
    confirm-class="btn-primary"
    @confirm="saveDemo"
    :close-text="'Cancel'"
    close-class="btn-default pull-left"
    :isLoading="false"
    :showExit="false"
    data-testid="demo-modal"
  >
    <template v-slot:title>Demo Link Settings</template>

    <template v-slot:body>
      <div class="form-group ml-5 w-30">
        <div class="row">
          <div class="col-sm col-lg-2">
            <label for="intro-form"> Intro Form: </label>
            <div>
              <span class="mr-5">Off/On</span>
              <v-switch
                :emitOnMount="false"
                :selected="demoEmailSelected"
                @input="(value) => toggleNode('demoEmailSelected', 'newDemoEmail', value)"
                class="switch-button"
              >
                ></v-switch
              >
            </div>
          </div>
          <div class="col-sm col-lg-6">
            <label for="demo-email"
              >Send form data to (email)<span class="required">*</span>:</label
            >
            <input
              class="form-control demo-input"
              id="demo-email"
              type="text"
              v-model="newDemoEmail"
              :disabled="!demoEmailSelected"
            />
          </div>
        </div>
      </div>
      <div class="form-group ml-5 w-30 mt-30">
        <label for="custom-message">Custom Complete Message:</label>
        <div>
          <span class="text"
            >At the end of the demo - a default message thanks the participant for their
            participation. You can add custom text to the pop-up by entering it below.</span
          >
          <div class="mt-10">
            <span class="mr-5 mt-10">Off/On</span>

            <v-switch
              :emitOnMount="false"
              :selected="customCompleteMessageSelected"
              @input="
                (value) =>
                  toggleNode('customCompleteMessageSelected', 'newCustomCompleteMessage', value)
              "
              class="switch-button"
            >
              ></v-switch
            >
          </div>
        </div>

        <template v-if="customCompleteMessageSelected">
          <strong class="strong-small">Custom Completion Message Text:</strong>
          <textarea
            class="form-control"
            id="custom-message"
            type="text"
            v-model="newCustomCompleteMessage"
          >
          </textarea>
        </template>
      </div>

      <div class="form-group ml-5 w-30 mt-30">
        <label for="custom-redirect">Custom Redirect: </label>
        <div>
          <span class="text"
            >Including a custom redirect allows you to direct users to the page of your choosing
            upon completion (after completion message).</span
          >
          <div class="mt-10">
            <span class="mr-5">Off/On</span>

            <v-switch
              :emitOnMount="false"
              :selected="customRedirectUrlSelected"
              @input="
                (value) => toggleNode('customRedirectUrlSelected', 'newCustomRedirectUrl', value)
              "
              class="switch-button"
            >
            </v-switch>
          </div>
        </div>
        <template v-if="customRedirectUrlSelected">
          <strong class="strong-small">Redirect URL:</strong>
          <input
            class="form-control"
            id="custom-redirect"
            type="text"
            v-model="newCustomRedirectUrl"
          />
        </template>
      </div>
      <span class="required ml-5" id="required-input-size">*Required input</span>
    </template>
  </modal>
</template>

<script>
  import cloneDeep from 'lodash/cloneDeep';
  import Switch from '@shared/switch.vue';
  import { mapActions } from 'vuex';
  export default {
    data() {
      //use cloneDeep to persist data when user clicks inbox tab and click back into administration tab
      const newDemoEmail = cloneDeep(this.demoEmail);
      const versionConfig = cloneDeep(this.versionConfig);
      const newCustomCompleteMessage = versionConfig.completeModal
        ? versionConfig.completeModal.body
        : '';
      const newCustomRedirectUrl = versionConfig.feedbackRedirectUrl;
      const demoEmailSelected = newDemoEmail ? true : false;
      const customCompleteMessageSelected = newCustomCompleteMessage ? true : false;
      const customRedirectUrlSelected = newCustomRedirectUrl ? true : false;

      return {
        newDemoEmail,
        demoEmailSelected,
        newCustomCompleteMessage,
        customCompleteMessageSelected,
        newCustomRedirectUrl,
        customRedirectUrlSelected,
      };
    },

    props: {
      versionKey: {
        type: Number,
        required: true,
      },
      demoEmail: {
        type: String,
      },
      versionConfig: {
        type: Object,
      },
    },

    components: {
      'v-switch': Switch,
    },

    watch: {
      demoEmail(newVal) {
        if (newVal) this.demoEmailSelected = true;
        this.newDemoEmail = newVal;
      },
      versionConfig(newVal) {
        if (newVal.completeModal) {
          this.newCustomCompleteMessage = newVal.completeModal.body;
          this.customCompleteMessageSelected = true;
        }
        if (newVal.feedbackRedirectUrl) {
          this.newCustomRedirectUrl = newVal.feedbackRedirectUrl;
          this.customRedirectUrlSelected = true;
        }
      },
    },

    methods: {
      ...mapActions('editMode/version', ['updateVersion']),
      toggleNode(flagKey, valueKey, flagValue) {
        if (!flagValue) {
          this.$data[valueKey] = '';
        }
        this.$data[flagKey] = flagValue;
      },

      async saveDemo() {
        const payload = {
          demoEmail: this.newDemoEmail,
          versionConfigJson: {
            ...this.versionConfig,
            completeModal: {
              body: this.newCustomCompleteMessage,
            },
            feedbackRedirectUrl: this.newCustomRedirectUrl,
          },
        };

        await this.updateVersion({
          payload,
          versionKey: this.$route.params.resourceKey,
        });

        $('#demo-modal').modal('hide');
      },
    },
  };
</script>
<style lang="scss" scoped>
  #custom-message {
    resize: none;
  }
  #custom-redirect,
  #custom-message {
    width: 94%;
  }
  .required {
    color: red;
  }
  #required-input-size {
    font-size: small;
  }
  .text {
    display: block;
    width: 95%;
  }
  .switch-button {
    margin-bottom: 2px;
  }
  .strong-small {
    font-size: small;
  }
</style>
